import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Component({
  selector: 'app-menu-info',
  templateUrl: './menu-info.component.html',
  styleUrls: ['./menu-info.component.scss']
})
export class MenuInfoComponent implements OnInit {

  constructor(private authService : AuthService, private router : Router) { }

  ngOnInit() {
  }



  /**
   * Logout User from app and send to Public Home Page
   */
  logoutUser(){
    this.authService.logout()
    .then(() => {
        //console.log('logout');
        this.router.navigate(['']);
        //success
    }, ()=> {
      //error
      //console.log('error');
    });

  }


  /**
   * Open My CME Pages
   */
  openMyCME(){

  }

/**
 * Prinit Receipt for User Payment
 */
  printReceipt(){

  }


  /**
   * Open User Suscription Page
   */
  openSuscriptionPage(){

  }

  /**
   * Suggest a topic Page
   */
  openSuggenstATopic(){

  }


  /**
   * Open Profile page
   */
  openProfilePage(){

  }





}
